import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import AddChargesModal from './AddChargesModal'
import ServiceImage from '../assets/imgs/stylers-images/image1.png'
import ServiceCardImage from '../assets/imgs/service-card-image.png'
import SetSkillRateModal from './SetSkillRateModal'
import { useNavigate } from 'react-router-dom'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  maxHeight: '80vh',
  overflow: 'auto',
  p: -1,
  background:
    'transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 51%, #2992FB 100%) 0% 0% no-repeat padding-box',
  boxShadow: '0px 5px 20px #00000040',
  borderRadius: '16px',
  textAlign: 'center',
}

const ServiceTypesModal = ({
  handleServiceTypesModal,
  modalOpen = false,
  serviceTypes,
  screenName,
  service,
}) => {
  const navigate = useNavigate()
  const [addChargesModal, setAddChargesModal] = React.useState(false)
  const [addSkillChargesModal, setAddSkillChargesModal] = React.useState(false)
  const [selectedSubService, setSelectedSubService] = React.useState(null)
  const handleAddChargesModal = () => {
    if (modalOpen) {
      handleServiceTypesModal(false)
    }
    setAddChargesModal((prev) => !prev)
  }
  const handleSkillChargesModal = () => {
    if (modalOpen) {
      handleServiceTypesModal(false)
    }
    setAddSkillChargesModal(!addSkillChargesModal)
  }

  const handleServiceOnClick = () => {
    if (modalOpen) {
      handleServiceTypesModal(false)
    }
    if (screenName && screenName === 'add-or-edit-skills') {
      handleSkillChargesModal()
    } else {
      handleAddChargesModal()
    }
    if (screenName === 'client-profile') {
      navigate('/client-search')
    }
  }

  // console.log(service)

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => handleServiceTypesModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div className="text-center">
            <img
              src={service?.primary_image}
              alt="Service Card Image"
              className="p-0 w-100"
              height={255}
              style={{ objectFit: 'cover' }}
            />
            <h1
              className="fs-48 text-black my-3 text-capitalize"
              style={{ wordBreak: 'break-all', padding: '0 15px' }}
            >
              {service?.service?.name}
            </h1>
            <div
              className="service-types mb-2 text-center pointer"
              style={{
                maxHeight: '14rem',
                overflow: 'auto',
                margin: 'auto',
                width: '65%',
              }}
            >
              {/* {service?.subservices?.map((subService, index) => (
                ))} */}
              <p
                className="fs-24 font-weight-bold mb-3 text-white pointer text-capitalize"
                onClick={() => {
                  // setSelectedSubService()
                  handleAddChargesModal()
                }}
              >
                {service?.subservice?.name + '  '}
                (<span className="text-black">{service?.providers}</span>)
              </p>
            </div>
          </div>
        </Box>
      </Modal>
      <AddChargesModal
        toggleAddChargesModal={handleAddChargesModal}
        modalOpen={addChargesModal}
        selectedSubService={service}
      />
      <SetSkillRateModal
        handleSetSkillRateModal={handleSkillChargesModal}
        SetSkillRateModal={addSkillChargesModal}
      />
    </>
  )
}

export default ServiceTypesModal
